import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import authApi from "../../api/authApi";

import useMount from "../../hooks/useMount";
import { getLabel } from "../../tools/Dictionary";

import logo from "../../images/Innovair_logo.png";

const AuthVerify = (props) =>
{
  //Routing
  const Location = useLocation();
  const Navigate = useNavigate();

  //Variables
  const component = "AuthVerify";

  //State
  const [loading, setLoading] = useState(true);
  const [fatal, setFatal] = useState(false);

  useMount(() =>
  {
    const verifyEmail = async() => 
    {

      const searchParams = new URLSearchParams(Location.search);

      const email = searchParams.get("email");
      const verifyCode = searchParams.get("verifyCode");

      if (!email || !verifyCode){
        setFatal(true);
        return;
      }

      try{

        let response = await authApi.verifyAuth({email, verifyCode});

        if (!response.Success) throw new Error();

        setLoading(false);

      }catch(err){
        setFatal(true);
        return;       
      }


    }

    verifyEmail();

  }, []);


  if (fatal)
    return (
      <div className="auth_page_cont">
        <div className="auth_verify_fatal">
          {getLabel("App", "Sorry, an unknown error has occurred. Please try again later or contact our support team for assistance.")}
          <input
            type="button"
            className="page_button auth_cont_login_button"
            style={{fontSize: "110%", width: "140px", marginTop: "20px"}}
            value={getLabel("App", "Home")}
            onClick={() => Navigate("/")}
          />
        </div>
      </div>
    );
  

  if (loading)
    return (
      <div className="auth_page_cont">
        <div className="page_loading" style={{fontSize: "160%"}}>
          {getLabel("App", "Loading")}<span>.</span><span>.</span><span>.</span>
        </div>
      </div>
    );

    return (
      <div className="auth_page_cont">
        <div className="auth_page_title">
          <img src={logo} alt="logo" style={{ width: "50%" }} />
        </div>
        <div className="auth_cont" style={{minHeight: "340px"}}>
          <div className="auth_cont_title">
            {getLabel(component, "Email Verification")}
          </div>
          <div className="auth_cont_body">
            <div className="auth_verify_text">
              {getLabel(component, "Congratulations! Your email address has...")}
            </div>
            <div className="auth_verify_text">
              {getLabel(component, "Please note that your account may need to be validated before you...")}
            </div>
          </div>
          <div className="auth_fill_footer" style={{ marginTop: "10px" }}>
            <input
              type="button"
              className="page_button auth_cont_login_button"
              value={getLabel("App", "Home")}
              onClick={() => Navigate("/")}
            />
          </div>
        </div>
      </div>
    );


}

export default AuthVerify;